import { render } from "./GeneralModal.vue?vue&type=template&id=ab548304"
import script from "./GeneralModal.vue?vue&type=script&lang=js"
export * from "./GeneralModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__